import { ContactUs } from '@components/Common/ContactUs';
import { LoginCard } from '@components/Login/LoginCard';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ErrorMessage, NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { EmailLogin as EmailLoginForm, tracking, useAuthContext } from 'noddi-web';
import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { getCommonTranslations } from '../../utils/commonTranslations';
import { getErrorCodesWithTrans } from '../../utils/getErrorCodesWithTranslations';

export const EmailLogin = () => {
  const { isLoggedIn } = useAuthContext();
  const { brandEmail, currentBrand } = useCurrentBrand();
  const [errorMessage, setErrorMessage] = useState('');

  if (isLoggedIn) {
    return <Navigate replace to={customerRoutes.userSelection.getBasePath()} />;
  }

  return (
    <LoginCard title={t`Sign in with email`}>
      <EmailLoginForm
        enablePasswordReset
        brandDomain={currentBrand}
        setErrorMessage={setErrorMessage}
        translations={getCommonTranslations().emailLoginTranslations}
        errorCodes={{ ...getErrorCodesWithTrans(brandEmail), user_does_not_exist: t`No account found for that email.` }}
        trackUserIdentity={(user) => {
          tracking.trackUserLogin(user);
        }}
      />
      {errorMessage && <ErrorMessage message={errorMessage} />}

      <NoddiLink variant='link' size='small' className='self-start p-0' to={customerRoutes.login.getPath()}>
        <Trans>Sign in with phone number instead</Trans>
      </NoddiLink>

      <ContactUs className='text-sm' customText={t`if you're having trouble signing in`} />
    </LoginCard>
  );
};
